import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText';

import App from '../../../assets/js/app';

import DetectController from '../../../assets/js/controllers/detect';

gsap.registerPlugin(SplitText);

export default class HeroContact {

	static selector = 'hero-contact';

	el = {};

	isDesktop;
	timelineShow;

	constructor(container) {
		this.el = {
			container,
			heading: container.querySelector('.h1'),
			content: container.querySelectorAll('.content-secondary ul li'),
			below: container.nextElementSibling
		};

		this.isDesktop = DetectController.isDesktop;

		if (this.isDesktop) {
			this.heading = new SplitText(this.el.heading, {
				type: 'lines'
			});

			const rotations = [40, 50, 60, 70, 80];

			for (const [i, line] of this.heading.lines.entries()) {
				gsap.set(line, {
					autoAlpha: 0,
					scale: 1 - i * 0.05,
					rotationX: rotations[i] * -1,
					y: this.heading.lines[0].offsetHeight,
					transformOrigin: '50% 50% -150'
				});
			}

			this.addEventListeners();
		}
	}

	addEventListeners() {
		App.on('preloadComplete', this.#onPreloadComplete);
		App.on('pageTransition', this.#onPageTransition);
	}

	removeEventListeners() {
		App.off('preloadComplete', this.#onPreloadComplete);
		App.off('pageTransition', this.#onPageTransition);
	}

	#onPreloadComplete = () => {
		this.show();
	};

	#onPageTransition = () => {
		this.show();
	};

	show() {
		this.timelineShow = gsap.timeline({});

		for (const [i, line] of this.heading.lines.entries()) {
			this.timelineShow
				.to(line, {
					ease: 'power4.inOut',
					rotationX: 0,
					y: 0,
					scale: 1,
					autoAlpha: 1,
					duration: 1.5,
					delay: i === 0 ? 0 : i * 0.1,
					transformOrigin: '50% 50% -150'
				}, 'start');
		}

		this.timelineShow
			.fromTo(this.el.content, {
				autoAlpha: 0,
				y: 50
			}, {
				ease: 'power4.out',
				autoAlpha: 1,
				rotationX: 0,
				duration: 1,
				y: 0,
				stagger: {
					each: 0.1
				}
			}, '-=0.75')
			.fromTo(this.el.below, {
				autoAlpha: 0
			}, {
				ease: 'power4.out',
				autoAlpha: 1,
				duration: 1
			}, 'start+=1');
	}

	destroy() {
		this.removeEventListeners();
	}

}
